import React, { useEffect, useState } from "react";
import ResponsiveDataManagement from "../../Components/Common/ResponsiveManagementLayout";
import SupplierService from "../../services/OrderingServices/SupplierService";
import SupplierForm from "./component/SupplierForm";
import DeleteModal from "../../Components/Common/DeleteModal";
import toast from "react-hot-toast";
import useTableSearch from "../../hooks/useTableSearch";
import {
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const Supplier = () => {
  const [supplierList, setSupplierList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const fetchSuppliers = async () => {
    try {
      setLoading(true);
      const response = await SupplierService.getList(1, 100);
      setSupplierList(
        response.map((item) => ({ ...item, dropdownOpen: false }))
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const { searchTerm, setSearchTerm, filteredData } = useTableSearch(
    supplierList,
    ["name", "phone", "contactPerson", "email", "panNumber", "address"]
  );

  const handleAdd = () => {
    setSelectedSupplier(null);
    setAddModal(true);
  };

  const handleEdit = (supplier) => {
    setSelectedSupplier(supplier);
    setAddModal(true);
  };

  const handleDeleteClick = (supplier) => {
    setSelectedSupplier(supplier);
    setDeleteModal(true);
  };

  const handleDelete = async () => {
    if (!selectedSupplier) return;
    try {
      await SupplierService.delete(selectedSupplier.id);
      setSupplierList((prev) =>
        prev.filter((item) => item.id !== selectedSupplier.id)
      );
      toast.success("Supplier deleted successfully");
    } catch (error) {
      toast.error("Failed to delete supplier");
    } finally {
      setDeleteModal(false);
      setSelectedSupplier(null);
    }
  };

  const toggleDropdown = (id) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      width: "75px",
    },
    { name: "Name", selector: (row) => row.name, sortable: true },
    {
      name: "Contact Person",
      selector: (row) => row.contactPerson,
      sortable: true,
    },
    { name: "Email", selector: (row) => row.email, sortable: true },
    { name: "Phone No", selector: (row) => row.phone, sortable: true },
    { name: "Pan No", selector: (row) => row.panNumber, sortable: true },
    { name: "Address", selector: (row) => row.address, sortable: true },
    // {
    //   name: "Action",
    //   selector: (row) => (
    //     <Dropdown
    //       isOpen={openDropdownId === row.id}
    //       toggle={() => toggleDropdown(row.id)}
    //     >
    //       <DropdownToggle
    //         color="light"
    //         className="btn-sm rounded-circle shadow-sm"
    //       >
    //         <i className="ri-more-2-fill" />
    //       </DropdownToggle>
    //       <DropdownMenu end>
    //         <DropdownItem onClick={() => handleEdit(row)}>
    //           <i className="ri-edit-line me-2 text-warning" /> Edit
    //         </DropdownItem>
    //         <DropdownItem onClick={() => handleDeleteClick(row)}>
    //           <i className="ri-delete-bin-line me-2 text-danger" /> Delete
    //         </DropdownItem>
    //       </DropdownMenu>
    //     </Dropdown>
    //   ),
    //   center: true,
    // },
  ];

  return (
    <>
      <ResponsiveDataManagement
        title="Suppliers"
        pageTitle="User Management"
        mobileCardTitle="Supplier List"
        data={filteredData}
        columns={columns}
        searchKeys={[
          "name",
          "contactPerson",
          "email",
          "phone",
          "panNumber",
          "address",
        ]}
        loading={loading}
        onAdd={handleAdd}
        onEdit={handleEdit}
        mobileCardRenderer={(item) => (
          <Card className="shadow-sm rounded-3 border-0 border-start border-4 border-success mb-3">
            <CardBody className="p-3">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <h6 className="fw-bold mb-1 text-primary">{item.name}</h6>
                  <p className="text-muted mb-1">
                    <strong>Contact Person:</strong> {item.contactPerson || "-"}
                  </p>
                  <p className="text-muted mb-1">
                    <i className="bx bx-envelope me-1" /> {item.email || "-"}
                  </p>
                  <p className="text-muted mb-1">
                    <i className="bx bx-phone me-1" /> {item.phone || "-"}
                  </p>
                  <p className="text-muted mb-1">
                    <strong>Pan No:</strong> {item.panNumber || "-"}
                  </p>
                  <p className="text-muted mb-0">
                    <strong>Address:</strong> {item.address || "-"}
                  </p>
                </div>
                <div>
                  <Dropdown
                    isOpen={openDropdownId === item.id}
                    toggle={() => toggleDropdown(item.id)}
                    direction="down"
                  >
                    <DropdownToggle
                      color="light"
                      className="btn-sm rounded-circle shadow-sm"
                    >
                      <i className="ri-more-2-fill" />
                    </DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem onClick={() => handleEdit(item)}>
                        <i className="ri-edit-line me-2" />
                        Edit
                      </DropdownItem>
                      {/* <DropdownItem onClick={() => handleDeleteClick(item)}>
                        <i className="ri-delete-bin-line me-2" />
                        Delete
                      </DropdownItem> */}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </CardBody>
          </Card>
        )}
      />

      <SupplierForm
        modal={addModal}
        toggleModal={() => setAddModal(false)}
        supplierList={supplierList}
        setSupplierList={setSupplierList}
        selectedItem={selectedSupplier}
        fetchSuppliers={fetchSuppliers}
      />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
        selectedItem={selectedSupplier}
      />
    </>
  );
};

export default Supplier;
